import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=370823b2&"
import script from "./Process.vue?vue&type=script&lang=ts&"
export * from "./Process.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports